import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { TeiHubLinkOrdersModel } from "features/hublink/core/domain/tei-hub-link.model";
import {
  GetTeiHubLinkOrdersResponse,
  GetTeiHubLinkOrdersRepository,
} from "features/hublink/data/tei-hub-link.repository";

export enum TeiHubLinkOrders {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: TeiHubLinkOrders;
  message: string;
  data: TeiHubLinkOrdersModel | undefined;
}

const initialState: InitialState = {
  status: TeiHubLinkOrders.initial,
  message: "",
  data: undefined,
};

export const teiHubLinkOrders = createAsyncThunk(
  "teiHubLinkOrders",
  async (param: string, { rejectWithValue }) => {
    try {
      const response: GetTeiHubLinkOrdersResponse =
        await GetTeiHubLinkOrdersRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const teiHubLinkOrdersSlice = createSlice({
  name: "teiHubLinkOrders",
  initialState,
  reducers: {
    resetTeiHubLinkOrders: (state) => {
      state.status = TeiHubLinkOrders.inProgress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(teiHubLinkOrders.pending, (state) => {
        state.status = TeiHubLinkOrders.inProgress;
      })
      .addCase(teiHubLinkOrders.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = TeiHubLinkOrders.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(teiHubLinkOrders.rejected, (state, action) => {
        state.status = TeiHubLinkOrders.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectTeiHubLinkOrders = (state: RootState) =>
  state.teiHubLinkOrders;

export const { resetTeiHubLinkOrders } = teiHubLinkOrdersSlice.actions;
export default teiHubLinkOrdersSlice.reducer;
